import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=067c2ee8&"
import script from "./Input.vue?vue&type=script&lang=js&"
export * from "./Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports